<div class="content">

  <app-user-info *ngIf="user$ | async as user" [user]="user"></app-user-info>

  <mat-divider></mat-divider>

  <mat-nav-list>
    <ng-container *ngFor="let item of items$ | async">
      <ng-container *appFeatureFlag="item.featureFlag || '!disabled'">
        <h3 mat-subheader *ngIf="item.type === 'header'">{{item.label}}</h3>
        <mat-list-item *ngIf="item.type === 'item'" (click)="navigate(item)">
          <mat-icon>{{item.icon}}</mat-icon>
          <span>{{item.label}}</span>
        </mat-list-item>
      </ng-container>
    </ng-container>
  </mat-nav-list>

  <div class="footer">
    <img class="logo" src="../assets/coronacapital.svg" alt="Corona Capital" />
    <!-- The running bundle's version (console-automatic-upgrade): equals the
         image's `sha-<short>` tag. `dev` outside CI images. -->
    <span class="version">{{version}}</span>
  </div>

</div>
